// @flow strict
import * as React from 'react';
import useI18n from 'src/hooks/useI18n';
import {useDispatch} from 'react-redux';
import {ERROR_CODES} from 'src/components/authentication/errors.js';
import {getUserDetails} from 'src/action-creators/referrer-portal/authentication.js';
//$FlowFixMe[nonstrict-import]
import * as reduxApi from 'src/utils/redux-api-referrer-portal';
import {
  type FileObject,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FileUpload,
  Button,
  Link,
  InContextAlert,
} from '@spaced-out/ui-design-system/lib/components/index';

import css from 'src/components/referrer-portal/settings/settings.css';


type FileUploadCallbacks = {
  onProgress: (number) => void,
  onSuccess: () => void,
  onError: (string) => void,
};

const UploadProfile = ({isEdit}: {isEdit?: boolean}): React.Node => {
  const dispatch = useDispatch();
  const {labelI18nInstance} = useI18n();
  const t = labelI18nInstance.t;

  const [file, setFile] = React.useState(null);
  const [apiError, setApiError] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const handleFileUpload = async (
    fileObject: ?FileObject,
    callbacks: ?FileUploadCallbacks,
  ) => {
    if (!fileObject) {
      return;
    }
    callbacks?.onProgress(40);
    callbacks?.onProgress(100);
    callbacks?.onSuccess();
    setFile(fileObject.file);
  };

  const handleSubmit = () => {
    const formData = new FormData();
    if (!file) {
      return;
    }
    const fileType = file.type.split('/')[1];

    formData.append('image', file);
    formData.append('file_type', fileType);
    // $FlowFixMe[class-object-subtyping]
    dispatch(reduxApi.post('user/picture', formData))
      .then(() => {
        setIsModalOpen(false);
        dispatch(getUserDetails());
      })
      .catch((error) => {
        if (error?.responseBody?.message) {
          setApiError(error.responseBody.message);
        }
      });
  };

  return (
    <>
      <Link as="buttonTextMedium" onClick={() => setIsModalOpen(true)}>
        {isEdit ? t('Edit', 'Edit') : t('Add', 'Add')}
        {` ${t('Profile_picture', 'Profile picture')}`}
      </Link>

      <Modal size="medium" isOpen={isModalOpen}>
        <ModalHeader onCloseButtonClick={() => setIsModalOpen(false)}>
          {t('Profile_Picture', 'Profile Picture')}
        </ModalHeader>
        <ModalBody className={css.flexColumn}>
          <FileUpload
            label={t('Upload_Profile_Picture', 'Upload Profile Picture')}
            instruction={t(
              'The_file_size_should_be_less_than_1_MB',
              'The file size should be less than 1 MB',
            )}
            secondaryInstruction={t(
              'Types_png_jpeg_Max_size_1mb',
              'Types: .png, .jpeg   Max. size: 1mb',
            )}
            maxSize={1000000}
            accept={{'image/jpeg': ['.jpg', '.jpeg'], 'image/png': ['.png']}}
            instruction={file?.name}
            onValidFilesDrop={(fileObjectArray, callbacks) => {
              handleFileUpload(fileObjectArray[0], callbacks);
            }}
            onRejectedFilesDrop={() => {
              handleFileUpload(null);
            }}
            classNames={{wrapper: css.fileUpload}}
          />
          {apiError && (
            <InContextAlert semantic="danger" classNames={{wrapper: css.alert}}>
              {ERROR_CODES[apiError] || apiError}
            </InContextAlert>
          )}
        </ModalBody>
        <ModalFooter>
          <Button type="ghost" onClick={() => setIsModalOpen(false)}>
            {t('Cancel', 'Cancel')}
          </Button>
          <Button disabled={!file} onClick={handleSubmit}>
            {t('Save', 'Save')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default UploadProfile;
